/* lp-hotspots.js — the saddler specimen: five numbered points on a photograph, each swapping the
   copy in the lens beside it. Ported 16 Sep 2026 from the prototype's bindery IIFE (setPoint/fill,
   the L array, the .adot handlers). Behaviour identical: click a dot → the lens takes that point's
   photograph, number line, heading, body and spec; the dot goes gold; below 900px the lens is scrolled
   into view. The points' copy comes from the section's blocks as JSON. */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('lp-hotspots')) return;

  class LPHotspots extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      var lens = this.querySelector('[data-lens]');
      var data = this.querySelector('script[type="application/json"][data-points]');
      var dots = Array.prototype.slice.call(this.querySelectorAll('.adot'));
      if (!lens || !data || !dots.length) return;
      var L; try { L = JSON.parse(data.textContent) || []; } catch (e) { L = []; }
      var active = -1;
      function field(k) { return lens.querySelector('[data-lens-' + k + ']'); }
      var img = field('img');
      function fill(x) {
        if (img) { if (x.img) { img.src = x.img; img.alt = x.alt || ''; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; } }
        ['num', 'h', 'p', 's'].forEach(function (k) { var e = field(k); if (e) e.textContent = x[k] || ''; });
      }
      function setPoint(i) {
        if (i === active || !L[i]) return;
        active = i;
        fill(L[i]);
        dots.forEach(function (o) { o.classList.toggle('on', parseInt(o.getAttribute('data-i'), 10) === i); });
      }
      var unbind = [];
      dots.forEach(function (d) {
        var fn = function () {
          setPoint(parseInt(d.getAttribute('data-i'), 10));
          if (window.innerWidth < 900 && lens.scrollIntoView) lens.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        };
        d.addEventListener('click', fn); unbind.push(function () { d.removeEventListener('click', fn); });
      });
      /* the theme editor: selecting a point block shows that point */
      var self = this;
      var onSel = function (e) { var t = e.target; if (!t || !self.contains(t) || !t.closest) return; var src = t.closest('[data-point-index]'); if (src) setPoint(parseInt(src.getAttribute('data-point-index'), 10)); };
      document.addEventListener('shopify:block:select', onSel); unbind.push(function () { document.removeEventListener('shopify:block:select', onSel); });
      this._unbind = function () { unbind.forEach(function (f) { f(); }); };
      this.setPoint = setPoint;
      setPoint(0);
    }
    disconnectedCallback() { if (this._unbind) { this._unbind(); this._unbind = null; } }
  }
  customElements.define('lp-hotspots', LPHotspots);
})();
